import { useAccount } from '@/hooks/useAccount';
import { getFlirtingStyleIdByTitle } from '@/pages/Onboarding/options/FlirtingStyle/utils/getFlirtingStyle';
import { getHisTypeIdByTitle } from '@/pages/Onboarding/options/HisType/utils/getHisType';
import { getHisVoiceIdByTitle } from '@/pages/Onboarding/options/HisVoice/utils/getHisVoice';
import { getHobbiesInterestsIdByTitle } from '@/pages/Onboarding/options/HobbiesInterests/utils/getHobbiesInterests';

export const useTransLayoutSelections = () => {
  const { user } = useAccount();
  const onb_data = user?.onboarding_data || {};

  return {
    his_type: getHisTypeIdByTitle(onb_data.his_type),
    his_voice: getHisVoiceIdByTitle(onb_data.his_voice),
    flirting_style: getFlirtingStyleIdByTitle(onb_data.flirting_style),
    hobbies_interests: getHobbiesInterestsIdByTitle(onb_data.hobbies_interests),
  };
};
